import { onLoad, onReady } from "../../exports/dom";
import { defineEvent } from "../nexus/defines.js";
import { events } from "../../exports/event-q-bus";
import { trackLegacySelectors } from "./async/tracking";
import { hardcoreLegacy, insertHtmlFragment } from "./async/fragment";
import { initializeMountingHooks, onMount, onUnmount } from "./async/hooks";
import type { EventLoaderEvents } from "../event-loader";
import { nexus } from "../../exports/nexus.js";

/*                                   */
nexus().dom.assignNamespace({
  onLoad: defineEvent(),
  onReady: defineEvent(),
  onMount,
  onUnmount,
  insertHtmlFragment,
  activateInlineScripts: hardcoreLegacy.activateInlineScripts,
});

/*                                                 */
const legacy = events<EventLoaderEvents>();
legacy.once("assets.events.documentReady", (e) => onReady.set(e));
legacy.once("assets.events.windowLoad", (e) => onLoad.set(e));

/*                    */
initializeMountingHooks();
onLoad.sub(trackLegacySelectors);
